// extracted by mini-css-extract-plugin
export default {"teamInfo":"TeamInfo_teamInfo__1zE9G","teamsPicker":"TeamInfo_teamsPicker__2KAyD"};